module.exports = __webpack_public_path__ + "static/media/alcogate-4.d8add93d.jpg";